import { render, staticRenderFns } from "./DonutChart42.vue?vue&type=template&id=41f4e8a2&scoped=true"
import script from "./DonutChart42.vue?vue&type=script&lang=js"
export * from "./DonutChart42.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4e8a2",
  null
  
)

export default component.exports